import styled, { CSSObject } from 'styled-components';

const SectionStyled = styled.div(({ theme }) => ({
  marginTop: theme.space[8],
  boxSizing: 'border-box',
}));

interface SectionContentProps {
  sx?: CSSObject;
}

const SectionContentStyled = styled.div<SectionContentProps>(
  ({ theme, sx }) => {
    return {
      boxSizing: 'border-box',
      padding: `${theme.space[8]} 0`,
      ...sx,
    };
  },
);

export { SectionStyled, SectionContentStyled };
